// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"JW-z","sponsoredTooltipWrapper":"KW-z","sponsoredTooltip":"LW-z","newCard":"MW-z"};